import { Box } from "@mui/material";
import { CalendarIcon } from "@radix-ui/react-icons";
import { AlertCircle, FileText, Trash2, Upload, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { HOME } from "../../Utils/Utils";
import {
  ADD_INTENTION,
  LISTE_COMMUNE_SANS_PAGINATION,
  LISTE_PARAMETRE_CONFIG,
  POINT_SERVICE_USER,
  RECHERCHER_SUPERVISEUR_COMMERCIALE,
  SERVICE_PARTNER,
} from "../../Utils/constant";
import doc from "../../assets/images/demande.png";
import { deleteItem, find, store } from "../../services/service";
import { useConfigStore } from "../../store/ConfigStore";
import { useStoreBatiment } from "../../store/Paramettre/batimentStore";
import { useStoreEquipement } from "../../store/Paramettre/equipementStore";
import { useStoreForfait } from "../../store/Paramettre/forfaitStore";
import { useStoreApp } from "../../store/storeApp";
import { useStoreCommune } from "../../store/storeCommune";
import { useStoreServicePartner } from "../../store/storeServicePartner";
import CommuneAutocomplete from "../Widget/CommuneAutoComplete";
import { SubmitButton } from "../Widget/SubmitButton";

export const documentTypes = [
  { label: "CNI du représentant (recto)", value: "CNI_RECTO_REPRESENTANT" },
  { label: "CNI du représentant (verso)", value: "CNI_VERSO_REPRESENTANT" },
  { label: "Statuts de l'entreprise", value: "STATUTS" },
  { label: "Contrat de bail", value: "CONTRAT_BAIL" },
  { label: "Contrat FTTH", value: "CONTRAT_FTTH" },
  { label: "Bon de commande", value: "BON_DE_COMMANDE" },
];

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + " o";
  if (bytes < 1024 * 1024) return Math.round(bytes / 1024) + " Ko";
  return (bytes / (1024 * 1024)).toFixed(1) + " Mo";
};

export const DemandeIntention = ({ handleNext, numero }) => {
  const [msg, setMsg] = useState("");
  const [typeClient, setTypeClient] = useState(null);
  const [pointServices, setPointService] = useState([]);
  const [postPaidDocuments, setPostPaidDocuments] = useState([]);
  const listeServicePartner = useStoreServicePartner();
  const [numeroSuperviseur, setNumeroSuperviseur] = useState("");
  const code = useStoreApp();
  const [numeroAvantage, setNumeroAvantage] = useState("");
  const [venteEnAttente, setVenteEnAtttente] = useState([]);
  const [ticket, setTicket] = useState(null);
  const navigate = useNavigate();
  const listeCommune = useStoreCommune();
  const [communeId, setCommuneId] = useState(null);
  const param = useConfigStore();
  const [servicePartnerId, setServicePartnerId] = useState("");
  const [pointServiceId, setPointServiceId] = useState("");
  const [superviseur, setSuperviseur] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);

  const forfaits = useStoreForfait();
  const batiments = useStoreBatiment();
  const typeEquipements = useStoreEquipement();

  const handleAddDocument = (e, documentType) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const newDoc = {
      id: Date.now() + Math.random(),
      type: documentType,
      file,
      name: file.name,
      size: file.size,
    };

    setPostPaidDocuments((prev) => [
      ...prev.filter((doc) => doc.type !== documentType),
      newDoc,
    ]);
    e.target.value = null;
  };
  const getListeSuperviseur = () => {
    find(RECHERCHER_SUPERVISEUR_COMMERCIALE).then((result) => {
      setSuperviseur(result.data.donnee);
    });
  };

  const handleRemoveDocument = (documentId) => {
    setPostPaidDocuments((prev) => prev.filter((d) => d.id !== documentId));
  };

  useEffect(() => {
    find("/commerciale/abonnement/verifier-ventes-encours")
      .then((result) => {
        if (result.data.donnee.length > 0) {
          setVenteEnAtttente(result.data.donnee);
          document.getElementById("enAttenteVente").showModal();
        }
      })
      .catch((e) => {
        toast.error(
          "Impossible de vérifier les ventes en attente. Veuillez réessayer plus tard.",
        );
      });
    find(POINT_SERVICE_USER).then((result) => {
      setPointService(result.data.donnee);
    });
    listeCommune.getData(`${LISTE_COMMUNE_SANS_PAGINATION}?prestataireId=`);
    listeServicePartner.getData(SERVICE_PARTNER);
    getListeSuperviseur();
    batiments.batiments({ page: 0, param: "", size: 10 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exit = () => {
    window.history.back();
    localStorage.removeItem("numeroTicket");
    localStorage.removeItem("eligible");
  };

  const submit = (data) => {
    setIsSubmit(true);

    if (
      data.typeClient === "ENTREPRISE_POSTPAID" &&
      postPaidDocuments.length === 0
    ) {
      toast.error("Veuillez joindre au moins un document pour continuer");
      setIsSubmit(false);
      return;
    }

    const formData = new FormData();
    const requestData = {
      ...data,
      statusConfirmation: "CONFIRMER",
      contactSuperviseur: numeroSuperviseur,
      communeId: communeId,
    };
    Object.keys(requestData).forEach((key) => {
      if (requestData[key] !== undefined && requestData[key] !== null) {
        formData.append(key, requestData[key]);
      }
    });

    postPaidDocuments.forEach((doc, index) => {
      formData.append(`documents[${index}].fichier`, doc.file);
      formData.append(`documents[${index}].typeFichier`, doc.type);
    });

    store(ADD_INTENTION, "multipart/form-data", formData)
      .then((res) => {
        if (res.status === 200) {
          reset();
          setIsSubmit(null);
          setPostPaidDocuments([]);
          toast.success("Intention enregistrée");
          localStorage.setItem(
            "numeroTicket",
            res?.data?.eligibilite?.numeroTicket,
          );
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        setMsg(err?.response?.data?.donnee);
        document.getElementById("errorModal").showModal();
      });
  };

  useEffect(() => {
    param.getData(LISTE_PARAMETRE_CONFIG);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (superviseur?.superviseur?.length === 1) {
      setNumeroSuperviseur(superviseur?.superviseur[0]?.numero);
    }
  }, [superviseur]);

  const totalFichiers = postPaidDocuments.length;
  const typesRenseignes = new Set(postPaidDocuments.map((d) => d.type)).size;

  return (
    <>
      {/* ── Modal suppression ── */}
      <dialog id="delete" className="modal">
        <div className="modal-box max-w-md bg-white rounded-2xl shadow-2xl">
          <div className="text-center p-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <Trash2 className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Confirmer la suppression
            </h3>
            <p className="text-gray-600 mb-6">
              Êtes-vous sûr de vouloir supprimer ce rôle ? Cette action est
              irréversible.
            </p>
            <div className="flex items-center justify-center gap-3">
              <form method="dialog">
                <button className="px-6 py-3 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-all duration-200">
                  Annuler
                </button>
              </form>
              <button
                onClick={() => {
                  deleteItem(
                    `commericiale/abonnement/v3/${ticket}/supprimer-vente?motif=`,
                  )
                    .then((res) => {
                      if (res.status === 200) {
                        find(
                          "/commerciale/abonnement/verifier-ventes-encours",
                        ).then((result) => {
                          document.getElementById("delete").close();
                          setVenteEnAtttente(result.data.donnee);
                        });
                      }
                    })
                    .catch(() => {
                      document.getElementById("delete").close();
                      document.getElementById("error").showModal();
                    });
                }}
                className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-all duration-200 flex items-center gap-2"
              >
                <Trash2 className="h-4 w-4" />
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </dialog>

      {/* ── Modal erreur intention ── */}
      <dialog id="errorModal" className="modal">
        <div className="modal-box max-w-md bg-white rounded-2xl shadow-2xl">
          <div className="text-center p-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="text-sm font-mtn font-bold text-gray-900 mb-2">
              Oops! Impossible de faire cette action
            </h3>
            <p className="text-xs text-red-500">{msg}</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => document.getElementById("errorModal").close()}
                className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-all duration-200 flex items-center gap-2"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </dialog>

      {/* ── Modal erreur suppression ── */}
      <dialog id="error" className="modal">
        <div className="modal-box max-w-sm bg-white rounded-2xl shadow-2xl">
          <div className="text-center p-6">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Oops! Une erreur s'est produite
            </h3>
            <p className="text-gray-600 mb-6">{msg}</p>
            <div className="flex items-center justify-center gap-3">
              <button
                onClick={() => {
                  document.getElementById("delete").close();
                  document.getElementById("error").close();
                }}
                className="btn-sm rounded-md bg-red-500 text-white"
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      </dialog>

      {/* ── Modal ventes en attente ── */}
      <dialog id="enAttenteVente" className="modal">
        <div className="relative modal-box max-w-md bg-white rounded-2xl shadow-2xl">
          <h1 className="text-lg font-mtn font-bold">
            Liste des ventes en Attente
          </h1>
          <p className="text-red-500 text-xs">
            Vous avez une ou plusieurs intentions en attente
          </p>
          <button
            onClick={() => document.getElementById("enAttenteVente").close()}
            className="absolute top-7 right-2 rounded-full bg-slate-50 p-1"
          >
            <X size={17} />
          </button>
          <div className="space-y-2 mt-4">
            {venteEnAttente?.map((item) => (
              <div
                key={item?.id}
                className="bg-white rounded-xl border-slate-200 border px-3 py-2 shadow-sm"
              >
                <div className="mb-4 flex gap-2 items-center">
                  <p className="text-xs font-bold">
                    Ticket N°{item?.numeroTicket}
                  </p>
                  <p className="ml-auto text-xs flex gap-1 items-center font-medium">
                    <CalendarIcon />
                    {item?.dateCreation
                      ? new Date(item?.dateCreation).toLocaleString()
                      : "--"}
                  </p>
                </div>
                <div className="items-center">
                  <p className="text-xs flex gap-1">
                    Nom du client :{item?.nomClient}
                  </p>
                </div>
                <div className="my-1 flex items-center">
                  <div className="flex items-center gap-2">
                    <div className="px-3 border rounded-full py-1 text-xs text-orange-600 font-semibold">
                      {item?.etape?.toLowerCase().replace(/_/g, " ")}
                    </div>
                  </div>
                </div>
                <div className="mt-3 space-y-1 mb-2">
                  <div className="flex gap-1">
                    <button
                      onClick={() => {
                        navigate(
                          `${HOME}/abonnements/poursuivre-intention/${item?.numeroTicket}/${
                            item?.etape === "EN_ATTENTE_DE_PAIEMENT"
                              ? 2
                              : item?.etape === "EN_ATTENTE_DE_LIVRAISON"
                                ? 3
                                : item?.etape === "EN_ATTENTE_DE_IDENTIFICATION"
                                  ? 4
                                  : 5
                          }`,
                        );
                        window.location.reload();
                      }}
                      className="btn btn-sm bg-main text-xs"
                    >
                      Poursuivre
                    </button>
                    <button
                      onClick={() => {
                        setTicket(item?.id);
                        document.getElementById("delete").showModal();
                      }}
                      className="rounded-lg btn-sm text-red-600 bg-red-50 text-xs"
                    >
                      Suprimer la vente
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </dialog>

      {/* ── Contenu principal ── */}
      {isSubmit === null ? (
        <div className="flex justify-center my-28 w-full">
          <div className="text-center">
            <img className="mx-auto" src={doc} height={80} width={80} alt="" />
            <p className="font-light mt-2 text-sm">
              Intention d'abonnement enregistrée
            </p>
          </div>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit(submit)}
          className="shadow-sm border rounded w-fit lg:w-full p-3"
        >
          <h1 className="text-amber-500 font-mtn text-2xl font-semibold tracking-tight">
            Enregistrer une intention
          </h1>

          {/* Numéro de ticket */}
          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
            <label className="form-control xl:w-1/2 lg:w-1/2 md:w-1/2 w-full">
              <div className="label -mb-1">
                <span className="label-text font-medium">
                  N° ticket <span className="text-red-500">*</span>
                </span>
              </div>
              <input
                {...register("numeroTicket", { required: true })}
                type="text"
                defaultValue={numero}
                readOnly
                placeholder="N° de ticket de vérification"
                className="input input-bordered w-full h-10 text-sm"
              />
            </label>
          </div>

          <div className="my-3">
            <h2 className="font-medium">Client</h2>
            <hr />
          </div>

          {/* Champs client */}
          <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col items-center gap-x-3">
            <label className="form-control grid lg:grid-cols-2 md:grid-cols-2 xl:grid-cols-2 grid-cols-1 gap-2 w-full">
              <div>
                <label className="text-sm">
                  Nom et prenoms <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("nomPrenoms", { required: true })}
                  type="text"
                  placeholder="Nom & prénoms"
                  className="input input-bordered w-full h-10 text-sm"
                />
                {errors.nomPrenoms && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div>
                <label className="text-sm">Email</label>
                <input
                  {...register("email")}
                  type="email"
                  placeholder="Email"
                  className="input input-bordered w-full h-10 text-sm"
                />
              </div>

              <div>
                <label className="text-sm">
                  Numero Client <span className="text-red-500">*</span>
                </label>
                <input
                  {...register("contatct", { required: true })}
                  type="number"
                  min={0}
                  placeholder="Contact client"
                  className="input input-bordered w-full h-10 text-sm"
                />
                {errors.contatct && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div>
                <label className="text-sm">Second contact</label>
                <input
                  {...register("secondContact")}
                  type="number"
                  min={0}
                  placeholder="Second contact client"
                  className="input input-bordered w-full h-10 text-sm"
                />
              </div>

              {param?.data?.CHAMPS_NUMERO_AVANTAGE === "true" ||
              param?.data?.CHAMPS_NUMERO_AVANTAGE === null ? (
                <div>
                  <label className="text-sm">
                    Numero avantage <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="number"
                    {...register("numeroAvantage", { required: true })}
                    onChange={(e) => setNumeroAvantage(e.target.value)}
                    min={0}
                    placeholder="Numero pour les avantages"
                    className="input input-bordered w-full h-10 text-sm"
                  />
                  {errors.numeroAvantage && (
                    <p className="text-red-600 text-xs">Champs obligatoire</p>
                  )}
                </div>
              ) : null}

              <div>
                <label className="text-sm">
                  Type de client <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("typeClient", { required: true })}
                  onChange={(e) => {
                    localStorage.setItem("typeClient", e.target.value);
                    setTypeClient(e.target.value);
                    typeEquipements.listEquipement(e.target.value);
                  }}
                  className="select select-bordered w-full h-10"
                >
                  <option value="">type de client</option>
                  <option value="PARTICULIER">Particulier</option>
                  <option value="ENTREPRISE_PREPAID">Entreprise prepaid</option>
                  <option value="ENTREPRISE_POSTPAID">
                    Entreprise postpaid
                  </option>
                </select>
                {errors.typeClient && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              {(typeClient === "ENTREPRISE" ||
                typeClient === "ENTREPRISE_POSTPAID" ||
                typeClient === "ENTREPRISE_PREPAID") && (
                <div>
                  <label className="text-sm">
                    Nom de l'entreprise <span className="text-red-500">*</span>
                  </label>
                  <input
                    {...register("nomEntreprise", { required: true })}
                    type="text"
                    placeholder="Entreprise ...."
                    className="input input-bordered w-full h-10 text-sm"
                  />
                  {errors.nomEntreprise && (
                    <p className="text-red-600 text-xs">Champs obligatoire</p>
                  )}
                </div>
              )}

              <div>
                <label className="text-sm">
                  Type d'équipement <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("equipementId", { required: true })}
                  className="select select-bordered w-full h-10"
                  onChange={(e) => forfaits.forfaitByEquipe(e.target.value)}
                >
                  <option value="">type d'équipement</option>
                  {typeEquipements?.list?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
                {errors.equipementId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div>
                <label className="text-sm">
                  Forfait <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("forfaitId", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option value="">Choisir un forfait</option>
                  {forfaits?.ListForfait?.map((item) => (
                    <option key={item?.id} value={item?.id}>
                      {item?.designation} -{" "}
                      {item?.categorie?.replace("_", " ").toLowerCase()}
                    </option>
                  ))}
                </select>
                {errors.forfaitId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <div className="my-2">
                <label className="text-sm">
                  Type de batiment <span className="text-red-500">*</span>
                </label>
                <select
                  {...register("batimentId", { required: true })}
                  className="select select-bordered w-full h-10"
                >
                  <option value="">type de batiment</option>
                  {batiments?.data?.batiments?.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.designation}
                    </option>
                  ))}
                </select>
                {errors.batimentId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>
              <div className="my-2">
                <label className="text-sm">Point service</label>
                <select
                  value={
                    pointServices?.length === 1
                      ? pointServices[0]?.id
                      : pointServiceId
                  }
                  {...register("pointServiceId")}
                  onChange={(e) => setPointServiceId(e.target.value)}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} selected>
                    selectionnez un point service
                  </option>
                  {pointServices?.map((item) => (
                    <option value={item.id}>{item.designation}</option>
                  ))}
                </select>
                {errors.pointServiceId && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              {superviseur?.length > 1 ? (
                <>
                  <div className="my-2">
                    <label className="text-sm">
                      Superviseur <span className="text-red-500">*</span>
                    </label>
                    <select
                      {...register("nomSuperviseur", { required: true })}
                      onChange={(e) => {
                        setNumeroSuperviseur(
                          superviseur?.find(
                            (item) => item.nomPrenoms === e.target.value,
                          )?.numero,
                        );
                      }}
                      className="select select-bordered w-full h-10"
                    >
                      <option value="">selectionnez un superviseur</option>
                      {superviseur?.map((item) => (
                        <option key={item.nomPrenoms} value={item.nomPrenoms}>
                          {item.nomPrenoms}
                        </option>
                      ))}
                    </select>
                    {errors.nomSuperviseur && (
                      <p className="text-red-600 text-xs">Champs obligatoire</p>
                    )}
                  </div>
                  <div>
                    <label className="text-sm">
                      Contact du superviseur ou de l'agence.{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      placeholder="Contact du superviseur"
                      value={numeroSuperviseur}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>
                </>
              ) : (
                <>
                  <div>
                    <label className="text-sm">
                      Nom du superviseur ou de l'agence{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      {...register("nomSuperviseur")}
                      placeholder="Nom du superviseur"
                      defaultValue={superviseur[0]?.nomPrenoms}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>
                  <div>
                    <label className="text-sm">
                      Contact du superviseur ou de l'agence.{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      {...register("contactSuperviseur")}
                      placeholder="Contact du superviseur"
                      defaultValue={superviseur[0]?.numero}
                      className="input input-bordered w-full h-10 text-sm"
                      readOnly
                    />
                  </div>
                </>
              )}

              <div>
                <label className="text-sm">
                  Service partner <span className="text-red-500">*</span>
                </label>
                <select
                  value={
                    listeServicePartner?.data?.donnee?.length === 1
                      ? listeServicePartner?.data?.donnee[0]?.id
                      : servicePartnerId
                  }
                  {...register("servicePartnerId", { required: true })}
                  onChange={(e) => setServicePartnerId(e.target.value)}
                  className="select select-bordered w-full h-10"
                >
                  <option value={""} selected>
                    Choisir une service
                  </option>
                  {listeServicePartner?.data?.donnee?.map((item) => (
                    <option value={item?.id}>{item?.designation}</option>
                  ))}
                </select>
                {errors.servicePartner && (
                  <p className="text-red-600 text-xs">Champs obligatoire</p>
                )}
              </div>

              <CommuneAutocomplete
                setValue={setCommuneId}
                listeCommune={listeCommune}
              />

              <div>
                <label className="text-sm">Quartier</label>
                <input
                  {...register("quartier")}
                  type="text"
                  placeholder="quartier du client"
                  className="input input-bordered w-full h-10 text-sm"
                />
              </div>
            </label>
          </div>

          {/* ── OTP ── */}
          {param?.data?.CHAMPS_OTP === "true" ||
          param?.data?.CHAMPS_OTP === null ? (
            <label className="form-contro w-full">
              <div className="label -mb-1">
                <span className="label-text font-medium">
                  Code de confirmation <span className="text-red-500">*</span>
                </span>
              </div>
              <div className="flex items-center gap-3">
                <input
                  {...register("otp", { required: false })}
                  type="text"
                  placeholder="Code de confirmation du client"
                  className="input input-bordered w-full h-10 text-sm font-semibold"
                />
                <span
                  onClick={() => code.generate(numero, numeroAvantage)}
                  className="btn btn-sm bg-main"
                >
                  {code?.codeLoading && code?.code === null ? (
                    <>
                      <span className="loading loading-spinner loading-xs mx-2"></span>
                      generation du code
                    </>
                  ) : (
                    "Generer"
                  )}
                </span>
              </div>
              <div className="ml-1">
                <p className="text-xs mt-2 text-amber-500">
                  {code?.code !== null ? "Code généré avec succès" : ""}
                </p>
              </div>
            </label>
          ) : null}

          {typeClient !== "PARTICULIER" && (
            <div className="mt-6 rounded-xl border border-gray-200 overflow-hidden">
              {/* En-tête */}
              <div className="bg-neutral-50 border-b border-neutral-200 px-5 py-4 flex items-start gap-3">
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-gray-800">
                    Documents requis — Entreprise postpaid
                  </h3>
                  <p className="text-xs text-gray-500 mt-0.5">
                    Joignez les pièces justificatives · Plusieurs fichiers
                    acceptés par type · PDF, JPG, PNG
                  </p>
                </div>
                {totalFichiers > 0 && (
                  <div className="flex-shrink-0 text-right">
                    <span className="inline-flex items-center gap-1 bg-amber-400 text-white text-xs font-semibold px-2.5 py-1 rounded-full">
                      {totalFichiers} fichier{totalFichiers > 1 ? "s" : ""}
                    </span>
                    <p className="text-xs text-gray-400 mt-1">
                      {typesRenseignes} / {documentTypes.length} types
                    </p>
                  </div>
                )}
              </div>

              {/* Grille documents */}
              <div className="p-4 bg-gray-50">
                <div className="my-1">
                  <label className="text-sm">Numero RCCM</label>
                  <input
                    {...register("rccm")}
                    type="text"
                    placeholder="Numero RCCM"
                    className="input input-bordered w-full h-10 text-sm"
                  />
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {documentTypes.map((docType) => {
                    const docsForType = postPaidDocuments.filter(
                      (d) => d.type === docType.value,
                    );

                    const hasFiles = docsForType.length > 0;

                    return (
                      <div
                        key={docType.value}
                        className={`bg-white rounded-lg border transition-all duration-200 overflow-hidden ${
                          hasFiles
                            ? "border-amber-300 shadow-sm"
                            : "border-gray-200"
                        }`}
                      >
                        {/* Titre carte */}
                        <div
                          className={`px-3 py-2 flex items-center justify-between border-b ${hasFiles ? "border-amber-100 bg-amber-50" : "border-gray-100"}`}
                        >
                          <span className="text-xs font-semibold text-gray-700 truncate pr-2">
                            {docType.label}
                          </span>
                          {hasFiles ? (
                            <span className="flex-shrink-0 text-xs bg-amber-100 text-amber-700 font-semibold px-2 py-0.5 rounded-full">
                              {docsForType.length}
                            </span>
                          ) : (
                            <span className="flex-shrink-0 text-xs bg-gray-100 text-gray-400 px-2 py-0.5 rounded-full">
                              Aucun
                            </span>
                          )}
                        </div>

                        <div className="p-3">
                          {/* Liste fichiers joints */}
                          {docsForType.length > 0 && (
                            <div className="mb-2 space-y-1.5">
                              {docsForType.map((d) => (
                                <div
                                  key={d.id}
                                  className="flex items-center gap-2 bg-gray-50 border border-gray-100 rounded-md px-2 py-1.5"
                                >
                                  <FileText className="w-3 h-3 text-amber-500 flex-shrink-0" />
                                  <span
                                    className="flex-1 text-xs text-gray-700 truncate"
                                    title={d.name}
                                  >
                                    {d.name}
                                  </span>
                                  <span className="text-xs text-gray-400 flex-shrink-0">
                                    {formatFileSize(d.size)}
                                  </span>
                                  <button
                                    type="button"
                                    onClick={() => handleRemoveDocument(d.id)}
                                    className="flex-shrink-0 w-5 h-5 rounded flex items-center justify-center bg-red-50 hover:bg-red-100 transition-colors"
                                  >
                                    <X className="w-3 h-3 text-red-500" />
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}

                          {/* Bouton upload */}
                          <label className="flex items-center gap-2 w-full px-3 py-2 rounded-md border border-dashed border-gray-300 hover:border-amber-400 hover:bg-amber-50 cursor-pointer transition-all duration-150 group">
                            <Upload className="w-3.5 h-3.5 text-gray-400 group-hover:text-amber-500 flex-shrink-0 transition-colors" />
                            <span className="text-xs text-gray-500 group-hover:text-amber-600 transition-colors">
                              {hasFiles
                                ? "Ajouter un fichiers"
                                : "Parcourir un fichier"}
                            </span>
                            <input
                              type="file"
                              className="hidden"
                              accept=".pdf,.jpg,.jpeg,.png"
                              onChange={(e) =>
                                handleAddDocument(e, docType.value)
                              }
                            />
                          </label>
                        </div>
                      </div>
                    );
                  })}
                </div>

                {/* Barre de résumé globale */}
                {totalFichiers > 0 && (
                  <div className="mt-3 flex items-center gap-4 flex-wrap bg-white border border-gray-200 rounded-lg px-4 py-2.5">
                    <div className="flex items-center gap-1.5">
                      <div className="w-2 h-2 rounded-full bg-amber-400"></div>
                      <span className="text-xs text-gray-500">
                        <strong className="text-gray-700">
                          {totalFichiers}
                        </strong>{" "}
                        fichier{totalFichiers > 1 ? "s" : ""} joint
                        {totalFichiers > 1 ? "s" : ""}
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <div className="w-2 h-2 rounded-full bg-gray-300"></div>
                      <span className="text-xs text-gray-500">
                        Taille totale :{" "}
                        <strong className="text-gray-700">
                          {formatFileSize(
                            postPaidDocuments.reduce((s, d) => s + d.size, 0),
                          )}
                        </strong>
                      </span>
                    </div>
                    <span className="ml-auto text-xs text-gray-400">
                      {typesRenseignes} / {documentTypes.length} types
                      renseignés
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
          {/* ══ FIN SECTION DOCUMENTS ══ */}

          {isSubmit === null ? null : (
            <SubmitButton
              isSubmit={isSubmit}
              label={"Enregistrer l'intention"}
            />
          )}
        </form>
      )}

      {/* Navigation */}
      <div className="w-full mt-4">
        <hr />
        <div
          className="flex mt-4"
          sx={{ display: "flex", flexDirection: "row", pt: 2 }}
        >
          <Box sx={{ flex: "1 1 auto" }} />
          <button
            disabled={isSubmit !== null ? true : false}
            className="bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg"
            onClick={isSubmit !== null ? exit : handleNext}
          >
            {isSubmit !== null ? "Quitter" : "Poursuivre"}
          </button>
        </div>
      </div>
    </>
  );
};
